import { Level1MenuItem } from "@/features";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { MdDescription } from "react-icons/md";
import { permissionsDocumentsReadonly } from "@/utils";
import { RootState, useAppSelector } from "@/app/store";

const parentPath = "documents";

export const DocumentMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const hasCompanies = useAppSelector(
    (state: RootState) => state?.auth?.user?.hasCompanies,
  );

  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Documents")}
      icon={<MdDescription size={18} className="mx-3" />}
      codes={permissionsDocumentsReadonly}
      feature="common"
      hide={!hasCompanies}
    />
  );
};
